import React from 'react';
import { ChipContainer, Icon, Text, getIcon } from './styles';

export function FlexChip({ text, type = 'info' }) {
  return (
    <ChipContainer type={type}>
      <Icon type={type}>{getIcon(type)}</Icon>
      <Text>
        <span>{text}</span>
      </Text>
    </ChipContainer>
  );
}
